import ExamDetailsFileUpload from '@/components/exames/exams-details/exam-detais-file/exam-details-file-upload/index.vue'
import ExamDetailsAssociate from '@/components/exames/exams-details/exam-detais-file/exam-details-associate/index.vue'
import CONSTANTS from '@/shared/constants/constants'
import ExamMixin from '@/shared/mixins/exam.mixin'

export default {
  name: 'exam-details-file',
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  mixins: [ExamMixin],

  components: {
    ExamDetailsFileUpload,
    ExamDetailsAssociate
  },
  data() {
    return {
      componentName: 'ExamDetailsFileUpload',
      Files: this.$i18n.t('files'),
      Associate: this.$i18n.t('associate_exam'),
      isOpeningXView: false
    }
  },
  computed: {
    isRepeat() {
      return this.details.status.name === 'Repetir'
    },

    showXViewButton() {
      const categoryId = this.details?.category?.id
      const studyInstanceUID = this.details?.studyInstanceUID

      const supportedCategories = new Set([
        CONSTANTS.CATEGORY.XRAY,
        CONSTANTS.CATEGORY.TOMOGRAFIA,
        CONSTANTS.CATEGORY.RESSONANCIA,
        CONSTANTS.CATEGORY.MAMOGRAFIA,
        CONSTANTS.CATEGORY.ULTRASSONOGRAFIA
      ])

      return supportedCategories.has(categoryId) && !!studyInstanceUID
    }
  },
  methods: {
    async handleGetExamXView() {
      if (this.isOpeningXView) return
      this.isOpeningXView = true

      const popup = window.open('about:blank', '_blank')

      this.$root.$emit('showLoading')
      try {
        const result = await this.getExamXView(this.details.examId)
        const examURL = result?.exameURL

        if (!examURL) {
          if (popup) popup.close()
          this.$toast.error(this.$t('no_exams'))
          return
        }
        if (popup) {
          popup.location.href = examURL
        } else {
          window.location.assign(examURL)
        }
      } catch (err) {
        if (popup) popup.close()
        this.$toast.error(this.$t('unexpected_error_occurred'))
      } finally {
        this.$root.$emit('hideLoading')
        this.isOpeningXView = false
      }
    }
  }
}
